import React from 'react';
import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

import {
  SkypassFooterSubNoticeContainer,
  StyledFooterNoticeTextBox,
  TextBold,
} from '@ecp/fo/sites/skypass/styles/footer/SkypassFooterBottomStyles';

export default function SkypassFooterNotice() {
  return (
    <SkypassFooterNoticeContainer>
      <Spacing top={'36px'} />
      <TextBox size={'16px'} weight={'bold'} height={'45px'}>
        이벤트 유의사항
      </TextBox>
      <Spacing top={'8px'} />
      <SkypassFooterSubNoticeContainer>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>이벤트 기간 : 2026년 10월 1일 (목) ~ 2026년 10월 31일 (토)
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>본 이벤트는 마일리지 몰 쇼핑에서 마일리지를 사용하고, 쇼핑 이벤트에 응모한 고객을 대상으로 합니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>대한항공 SKYPASS에 등록된 개인정보를 기준으로 경품 지급이 안내됩니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>잘못된 개인정보로 인한 발송 오류 시 재발송이 불가하오니, 사전에 개인정보를 확인해주시기 바랍니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>모든 경품은 명의 변경, 유효기간 연장, 교환 및 환불이 불가하며, 경품 내용 및 당첨 인원은 사전 고지 없이 변경 될 수 있습니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>본 이벤트에 참여하실 경우 개인정보 제공에 동의하신 것으로 간주되며, 발송을 위해 제공된 정보는 발송 후 60일 이내 폐기됩니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold></TextBold>(개인정보 위탁업체: (주)케이티알파 / 제공 개인정보 범위: 휴대전화번호)
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>해당 경품은 업체 사정에 따라 동일 스펙의 다른 상품으로 변경될 수 있습니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>당첨자 발표(항공권) : 2026년 11월 11일 (수) 대한항공 홈페이지
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>당첨자 발표(배달의민족 및 다이소 상품권) : 2026년 11월 11일 (수) 홈페이지 공지 없이 당첨자 대상 경품 발송 문자로 개별 안내
        </StyledFooterNoticeTextBox>
        <br/>
        <TextBox size={'14px'} weight={'bold'} height={'45px'}>
          [이벤트 1]
        </TextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>혜택① : 1회 이상 구매한 고객 중 추첨을 통해 푸켓 일반석 왕복 항공권 2매 증정
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>혜택② : 1만/3만 마일 이상 구매한 고객별 추첨을 통해 배달의민족 상품권 2만/5만원권 증정
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>혜택 ①, ②는 중복 당첨 가능합니다.
        </StyledFooterNoticeTextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>항공권 경품 집행을 위해 당첨자의 개인정보(이름, 연락처)가 (주)한진트래블에 제공되며, 항공권 발권 시 유류할증료 및 공항세 등 당첨자 본인 부담금이 발생할 수 있습니다.
        </StyledFooterNoticeTextBox>
        <br/>
        <TextBox size={'14px'} weight={'bold'} height={'45px'}>
          [이벤트 2]
        </TextBox>
        <StyledFooterNoticeTextBox>
          <TextBold>•</TextBold>혜택 : 이벤트 기간 중 올해 처음 상품을 구매한 고객 중 추첨을 통해 다이소 상품권 5천원권 증정
        </StyledFooterNoticeTextBox>
      </SkypassFooterSubNoticeContainer>
    </SkypassFooterNoticeContainer>
  );
}

const SkypassFooterNoticeContainer = styled(FlexBoxColumn)`
  background-color: ${(props) => props.theme.color.background.basic};
  align-items: flex-start;
  width: 1920px;
  height: 650px;
  padding-left: 290px;
`;
